import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { buildQuery } from '../../utils/buildQuery';
import { callApi } from '../../utils/callApi';
import { GetApps, TypeGetActionsR } from './actions';
import ActionTypes, { TAppsState } from './types';

function* getActionsWorker(action: ReturnType<typeof GetApps.request>): Generator {

  const { data, callBack, callBackFile } = action.payload as TypeGetActionsR;

  let success = true;
  const query = buildQuery(data);

  try {
    const resp = (yield call(callApi, {
      method: 'get',
      path: query ? `/apps?${query}` : '/apps',
    })) as TAppsState['data'];
    if (!callBackFile){
      yield put(GetApps.success(resp));
    } else{
      yield call(callBackFile, true, resp);
    }
  } catch (e) {
    success = false;
    yield put(GetApps.error(e as string));
  } finally {
    if (callBack) yield call(callBack, success);
  }
}

function* watchFetchRequest() {
  yield takeEvery(ActionTypes.GET_ACTIONS_R, getActionsWorker);
}

export default function* actionsSaga() {
  yield all([fork(watchFetchRequest)]);
}
